import classNames from 'classnames';
import { useEffect } from 'react';
import './RDCModal.scss';

interface RDCModalProps extends React.HTMLAttributes<HTMLDivElement> {
	variant?: 'red' | 'blue' | 'light';
	// Закрывать ли модальное окно при нажатии на Esc
	closeOnEsc?: boolean;
	// Callback при закрытии модального окна
	onRequestClose?: () => void;
}

export const RDCModal: React.FC<RDCModalProps> = ({
	variant = 'blue',
	children,
	className,
	style,
	closeOnEsc = true,
	onRequestClose,
	...otherProps
}) => {
	const modalClasses = classNames('rdc-modal', className, variant);

	// Закрытие модального окна при нажатии на Esc
	useEffect(() => {
		if (!closeOnEsc || !onRequestClose) {
			return;
		}
		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key === 'Escape') {
				onRequestClose();
			}
		};
		window.addEventListener('keydown', handleKeyDown);
		return () => {
			return window.removeEventListener('keydown', handleKeyDown);
		};
	}, [closeOnEsc, onRequestClose]);

	return (
		<div {...otherProps} className={modalClasses} style={style}>
			{children}
		</div>
	);
};
